import { useMemo } from "react";
import { useGetTotalUsersQuery } from "../../store/api/analyticsApi";

import { useViewershipDashboard } from "../../hooks/analytics/useViewershipDashboard";
import { useSubscriptionData } from "../../hooks/analytics/useSubscriptionData";
import { useAvodData } from "../../hooks/analytics/useAvodData";

import { fetchAndCompareDates } from "../../utils/analytics/fetchAndCompareDates";
import { formatNumber } from "../../utils/analytics/formatNumber";

export const useUsersInfo = (pub_id, isContentPartner = false) => {
  const { data: totalUsersRaw, isFetching } = useGetTotalUsersQuery(undefined, {
    skip: !pub_id || isContentPartner,
  });

  const data = useMemo(() => {
    if (isContentPartner) {
      return { totalUsers: 0, activeSubscriptions: 0 };
    }

    return {
      totalUsers: totalUsersRaw?.data?.total_user_count || 0,
      activeSubscriptions: totalUsersRaw?.data?.total_active_subscriptions || 0,
    };
  }, [totalUsersRaw, isContentPartner]);

  return { ...data, loading: !isContentPartner && isFetching };
};

export const useViewershipData = useViewershipDashboard;

export const getPublisherConfigInfo = (keyName) => {
  let response = false;

  if (
    localStorage.getItem("publisherConfig") &&
    typeof localStorage.getItem("publisherConfig") !== "undefined" &&
    localStorage.getItem("publisherConfig") !== "undefined"
  ) {
    const publisherConfig = JSON.parse(localStorage.getItem("publisherConfig"));
    if (publisherConfig) {
      const configInfo = publisherConfig.filter((item) => keyName == item.key_name);
      response = configInfo[0] && configInfo[0].key_value;
      return response;
    }
  }

  return response;
};

export { useSubscriptionData, useAvodData, formatNumber, fetchAndCompareDates };

export default {
  useViewershipData,
  useSubscriptionData,
  useAvodData,
  formatNumber,
  getPublisherConfigInfo,
};
